import React from "react";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useCreateLink";
import useParents from "@qpr/client-api-base/apihooks/useParents";
import BreadcrumbDesign from "design/components/toolbar/BreadcrumbDesign";
import HomeIcon from "design/components/icons/HomeIcon";
import { useCurrentTenant } from "@qpr/client-library/dist/esm";
import typeToView from "routing/typetoview";
import useModel from "backend/hooks/model/useModel";
import Loader from "@qpr/client-api-base/ui/components/Loader";

const Breadcrumb = () => {
  const ctx = useAppContext();
  const tenant = useCurrentTenant();
  const model = useModel();
  const parents = useParents(ctx.elementId || "");
  const link = useLink();
  const home = {
    url: `/${tenant.symbol}/${ctx.model || ""}/landingpage/${
      model ? model?.data?.[0]?.id : ""
    }`,
    icon: <HomeIcon />,
  };

  if (!parents) {
    return <Loader />;
  }

  if (
    !parents ||
    !ctx.elementId ||
    parents.length === 0 ||
    ctx.page === "landingpage"
  ) {
    return <BreadcrumbDesign items={[home, { title: "Home" }]} />;
  }

  // page: typeToView(value.typename),
  //
  return (
    <BreadcrumbDesign
      items={[
        home,
        ...parents
          .filter((p) => typeToView(p.typename))
          .map((p) => {
            return {
              title: p.name,
              url: link({ meaId: p.id, page: typeToView(p.typename) }),
            };
          }),
      ]}
    />
  );
};

export default Breadcrumb;
